import { createContext } from 'react';

export const JideEnvBarContext = createContext<
  | undefined
  | {
      raiseZIndex: boolean;
      toggleRaiseZIndex: (toggle: boolean) => void;
    }
>(undefined);
